import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useOperatorContext } from "@src/context/operatorContext";
import { useDCContext } from "@src/context";
import { AppUtils, useIsMobileWidth } from "@src/utils";
import OperatorHooks from "@src/context/hooks/operatorHooks";

import {
  BackButton,
  ImageWithRetry,
  Loader,
  TabSelector,
} from "@src/components/atoms";
import Carbon from "./Carbon";
import Donations from "./Donations";
import ErrorPage from "@src/components/layout/ErrorPage";

const ImpactPage = () => {
  const { profile } = useOperatorContext();
  const dc = useDCContext();
  const location = useLocation();
  const isMobile = useIsMobileWidth();
  const initialTab = location.hash === "#donations" ? "donations" : "carbon";
  const [tab, setTab] = useState(initialTab);
  const {
    data: { impact } = {},
    isPending: impactPending,
    error: impactError,
  } = OperatorHooks.useOperatorImpact(
    profile?.operator?.id,
    profile?.customer?.industry,
  );

  if (profile?.customer == null) {
    return <ErrorPage pageName={"impact"} />;
  }

  const enableDonationsTab = !!profile?.charities?.length;
  return (
    <div className="bg-teal-500">
      <section className="relative">
        <div className="px-5 pt-3 md:pt-8 md:absolute z-10">
          <BackButton trackingActionKey="IMPACT_BACK_BUTTON" />
        </div>
        <div className="hidden md:block -mb-20 h-[174px]">
          <ImageWithRetry
            className="w-full"
            src="https://signol-email-images.s3.eu-west-2.amazonaws.com/ImpactPage_Trees.svg"
            alt=""
          />
        </div>
        <div className="w-full text-white text-center pointer-events-none z-20">
          <h1 className="text-2xl md:text-4xl font-extrabold text-center leading-snug capitalize">
            {dc.getDynamicReplacement(
              "captain__impact__title",
              {},
              "Your Impact",
            )}
          </h1>
          <p>
            {dc.getDynamicReplacement(
              "captain__impact__subtitle",
              {},
              "We thank you for making a positive impact.",
            )}
          </p>
        </div>
        {enableDonationsTab && (
          <div className="md:inline-block md:absolute md:top-1/2 md:right-0 lg:right-10">
            <TabSelector
              position={isMobile ? "center" : "end"}
              options={[
                { key: "carbon", label: "Carbon" },
                { key: "donations", label: "Donations" },
              ]}
              selected={tab}
              onClick={(key) => {
                setTab(key);
              }}
              trackingActionKey="IMPACT_SWITCH_TAB"
            />
          </div>
        )}
      </section>

      {impactPending ? (
        <div className="min-h-120">
          <div className="w-full h-full flex items-center justify-center">
            <Loader size="2xl" />
          </div>
        </div>
      ) : impactError ? (
        <ErrorPage pageName={"impact"} />
      ) : (
        !!impact && (
          <div id={"impact-sections"}>
            {tab === "carbon" && (
              <Carbon
                operatorPeriodImpact={impact.operatorPeriodImpact}
                operatorYearlyImpact={impact.operatorYearlyImpact}
                customerYearlyImpact={impact.customerYearlyImpact}
              />
            )}
            {tab === "donations" &&
              profile.charities.map((charity) => (
                <Donations
                  key={charity.id}
                  charity={charity}
                  operatorPeriodImpact={impact.operatorPeriodImpact}
                  operatorYearlyImpact={impact.operatorYearlyImpact}
                  customerYearlyImpact={impact.customerYearlyImpact}
                />
              ))}
          </div>
        )
      )}
    </div>
  );
};

export const impactPageControls = {};

ImpactPage.propTypes = AppUtils.getPropTypeFromControls(impactPageControls);

export default ImpactPage;
